// src/pages/RacingArchive.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const seasons = [
  {
    id: 'outdoor-2026',
    emoji: '🌸',
    name: 'Spring/Summer Outdoor Track 2026',
    badge: 'OUTDOOR',
    badgeColor: '#15803d',
    badgeBg: '#dcfce7',
    dateRange: 'April – July 2026',
    accentColor: '#15803d',
    meetBg: 'rgba(34, 197, 94, 0.05)',
    championshipStyle: { background: 'linear-gradient(135deg, #bbf7d0 0%, #86efac 100%)', border: '1px solid #4ade80' },
    meets: [
      { date: 'Apr 26',    name: 'Bullseye Youth T&F Invitational',        location: 'Reservoir HS, MD' },
      { date: 'May 16',    name: '2026 Hardy 5K',                          location: "Fletcher's Cove, DC" },
      { date: 'May 24',    name: 'Clarksburg Coyotes T&F Club Championships', location: 'Clarksburg HS, MD' },
      { date: 'May 24',    name: 'White Knight Youth Challenge',           location: 'Calvert Hall College HS, MD' },
      { date: 'May 30',    name: 'H-Town Rollerz Youth T&F Invitational',  location: 'Williamsport HS, MD',
        link: 'https://storage.googleapis.com/anet_user_files/meet/tf/661400/2026_H-Town_Rollerz_Invitational-2.pdf', linkLabel: '📄 Meet flyer' },
      { date: 'Jun 6',     name: 'Bullseye/Yep T&F Summer Series #1',      location: 'Howard Community College, MD',
        link: 'https://storage.googleapis.com/anet_user_files/meet/tf/667032/Bullseye_Yep_Summer_Series_2026_FINAL_Version.png', linkLabel: '📄 Meet flyer' },
      { date: 'Jun 13–14', name: 'AAU Maryland District Qualifier',        location: 'Western Maryland College, MD', note: 'AAU membership required',
        link: 'https://storage.googleapis.com/anet_user_files/meet/tf/654211/AAU_District_Meet_Flyer_2026_-_260507.pdf', linkLabel: '📄 Meet flyer' },
      { date: 'Jun 18–21', name: 'Adidas Track Nationals 2026',            location: 'Marcus T. Johnson Track, Greensboro, NC', isChampionship: true, note: 'National championship meet',
        link: 'https://adidastfnationals.com/home', linkLabel: '🔗 Meet website' },
      { date: 'Jun 20',    name: 'Bullseye/Yep T&F Summer Series #2',      location: 'Howard Community College, MD' },
      { date: 'Jun 25–28', name: 'AAU Track & Field Region 3 Qualifier',   location: 'Morgan State University, MD', note: 'AAU membership required' },
      { date: 'Jul 18',    name: 'Bullseye/Yep T&F Summer Series #3',      location: 'Howard Community College, MD' },
      { date: 'Jul 25',    name: 'Bullseye/Yep T&F Summer Series #4',      location: 'Howard Community College, MD' },
    ],
    highlights: 'Our first full outdoor track season — invitationals across Maryland, AAU qualifiers, a summer series at Howard CC, and a trip to Adidas Track Nationals in Greensboro!'
  },
  {
    id: 'indoor-2026',
    emoji: '❄️',
    name: 'Winter Indoor Track 2026',
    badge: 'INDOOR',
    badgeColor: '#1e40af',
    badgeBg: '#dbeafe',
    dateRange: 'January – March 2026',
    accentColor: '#1e40af',
    meetBg: 'rgba(59, 130, 246, 0.05)',
    championshipStyle: { background: 'linear-gradient(135deg, #bfdbfe 0%, #a5b4fc 100%)', border: '1px solid #818cf8' },
    meets: [
      { date: 'Jan 5',     name: 'DCIAA Developmental Meet #1',  location: "Prince George's Sports Complex, Landover, MD" },
      { date: 'Jan 14',    name: 'DCIAA Developmental Meet #2',  location: "Prince George's Sports Complex, Landover, MD" },
      { date: 'Jan 25',    name: 'All Comers',                   location: "Prince George's Sports Complex, Landover, MD" },
      { date: 'Feb 8',     name: 'All Comers',                   location: "Prince George's Sports Complex, Landover, MD" },
      { date: 'Feb 14',    name: 'PVA 14 & Under Championship',  location: "Prince George's Sports Complex, Landover, MD" },
      { date: 'Feb 24',    name: 'DCIAA Championship',           location: "Prince George's Sports Complex, Landover, MD", isChampionship: true },
      { date: 'Feb 28',    name: 'PVA Youth Indoor Championship', location: "Prince George's Sports Complex, Landover, MD" },
      { date: 'Mar 12',    name: 'Nike Nationals',               location: 'New York City, NY',                            isChampionship: true, note: 'Qualifying standards required' },
      { date: 'Mar 20–22', name: 'Adidas Nationals',             location: 'Virginia Beach Sports Center, VA Beach, VA',   isChampionship: true, note: '3-day championship meet' },
    ],
    highlights: 'Our first indoor track season — from developmental meets at PG Sports Complex all the way to national championships in NYC and Virginia Beach!'
  },
  {
    id: 'xc-fall-2025',
    emoji: '🍂',
    name: 'Fall 2025 Cross Country',
    badge: 'XC',
    badgeColor: '#c53030',
    badgeBg: '#fed7d7',
    dateRange: 'September – November 2025',
    accentColor: '#c53030',
    meetBg: 'rgba(197, 48, 48, 0.05)',
    championshipStyle: { background: 'linear-gradient(135deg, #fed7d7 0%, #fbb6ce 100%)', border: '1px solid #f687b3' },
    meets: [
      { date: 'Sep 7',  name: 'Westminster Youth XC Meet',          location: 'Westminster HS, MD' },
      { date: 'Sep 14', name: 'Maryland Blaze XC Meet',             location: 'Mount Vista Park, MD' },
      { date: 'Sep 21', name: 'Bullseye Youth XC Meet',             location: 'Centennial HS, MD' },
      { date: 'Sep 28', name: 'Catonsville Youth XC Meet',          location: 'Catonsville High School, MD' },
      { date: 'Oct 5',  name: '18th Annual Catoctin Youth XC Meet', location: 'Utica Park, Frederick MD' },
      { date: 'Oct 12', name: 'Middletown Youth XC Meet',           location: 'Middletown Park, MD' },
      { date: 'Oct 19', name: 'Frederick Blaze Youth XC Meet',      location: 'Governor Thomas Johnson HS, MD' },
      { date: 'Oct 26', name: 'CMRC Youth XC Meet',                 location: 'Carroll Manor Elementary School, MD' },
      { date: 'Nov 2',  name: 'MD Youth CC Series at Frederick',    location: 'Maryland School for the Deaf, MD' },
      { date: 'Nov 16', name: 'Middle School XC Nationals 2025',    location: 'Tom Sawyer State Park, Louisville, KY', isChampionship: true },
    ],
    highlights: 'An incredible fall season with personal bests, team camaraderie, and unforgettable moments — from local meets all the way to national championships in Louisville!'
  }
];

function RacingArchive() {
  const [expandedSeasons, setExpandedSeasons] = useState(new Set());

  const toggleSeason = (id) => {
    setExpandedSeasons(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  return (
    <div className="page">
      {/* Hero */}
      <div style={{
        background: 'linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%)',
        padding: '3rem 2rem',
        borderRadius: '20px',
        textAlign: 'center',
        marginBottom: '2rem',
        border: '1px solid rgba(0,0,0,0.08)',
        position: 'relative'
      }}>
        <div style={{
          position: 'absolute', top: '1rem', right: '1rem',
          background: '#fbbf24', color: '#92400e',
          padding: '0.5rem 1rem', borderRadius: '20px',
          fontWeight: 'bold', fontSize: '0.9rem'
        }}>
          📚 ARCHIVE
        </div>
        <h1 style={{ color: '#374151', marginBottom: '1rem', fontSize: '2.5rem' }}>Past Seasons</h1>
        <p style={{ fontSize: '1.1rem', color: '#4A5568', maxWidth: '500px', margin: '0 auto' }}>
          A look back at where DC Hawks have competed.
        </p>
      </div>

      {/* Back button */}
      <div style={{ marginBottom: '2rem', textAlign: 'center' }}>
        <Link to="/racing" style={{
          display: 'inline-block', padding: '0.75rem 1.5rem',
          background: '#3b82f6', color: 'white',
          textDecoration: 'none', borderRadius: '8px', fontWeight: 'bold'
        }}>
          ← Back to Current Season
        </Link>
      </div>

      {/* Season accordion */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginBottom: '3rem' }}>
        {seasons.map(season => {
          const isOpen = expandedSeasons.has(season.id);
          return (
            <div key={season.id} style={{
              background: 'white',
              borderRadius: '12px',
              border: `2px solid ${isOpen ? season.accentColor : '#e5e7eb'}`,
              overflow: 'hidden',
              transition: 'border-color 0.2s ease',
              boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
            }}>
              {/* Header / toggle */}
              <button
                onClick={() => toggleSeason(season.id)}
                style={{
                  width: '100%', display: 'flex', alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '1.25rem 1.5rem',
                  background: 'none', border: 'none', cursor: 'pointer',
                  textAlign: 'left', gap: '1rem'
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
                  <span style={{ fontSize: '1.8rem' }}>{season.emoji}</span>
                  <div>
                    <div style={{ fontWeight: 'bold', fontSize: '1.15rem', color: '#1f2937' }}>
                      {season.name}
                    </div>
                    <div style={{ fontSize: '0.9rem', color: '#6b7280', marginTop: '0.15rem' }}>
                      {season.dateRange} · {season.meets.length} meets
                    </div>
                  </div>
                  <span style={{
                    background: season.badgeBg, color: season.badgeColor,
                    padding: '0.2rem 0.65rem', borderRadius: '20px',
                    fontSize: '0.75rem', fontWeight: 'bold', letterSpacing: '0.05em'
                  }}>
                    {season.badge}
                  </span>
                </div>
                <span style={{ fontSize: '1rem', color: '#9ca3af', flexShrink: 0 }}>
                  {isOpen ? '▲' : '▼'}
                </span>
              </button>

              {/* Expandable meets list */}
              {isOpen && (
                <div style={{ padding: '0 1.5rem 1.5rem', borderTop: '1px solid #f3f4f6' }}>
                  <div style={{ marginTop: '1rem' }}>
                    {season.meets.map((meet, i) => (
                      <div key={i} style={{
                        marginBottom: '0.6rem',
                        padding: '0.65rem 0.85rem',
                        background: meet.isChampionship ? season.championshipStyle.background : season.meetBg,
                        border: meet.isChampionship ? season.championshipStyle.border : 'none',
                        borderRadius: '6px',
                        fontSize: '0.95rem'
                      }}>
                        <strong>{meet.date}</strong>{meet.isChampionship ? ' ⭐' : ''} — {meet.name}<br />
                        <span style={{ color: '#666', fontSize: '0.9rem' }}>📍 {meet.location}</span>
                        {meet.note && (
                          <><br /><span style={{ color: season.accentColor, fontSize: '0.85rem', fontStyle: 'italic' }}>{meet.note}</span></>
                        )}
                        {meet.link && (
                          <>
                            {meet.note ? ' · ' : <br />}
                            <a
                              href={meet.link}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ color: season.accentColor, fontSize: '0.85rem' }}
                            >
                              {meet.linkLabel || 'More info'}
                            </a>
                          </>
                        )}
                      </div>
                    ))}
                  </div>
                  <div style={{
                    background: '#f0fdf4', padding: '1rem 1.25rem',
                    borderRadius: '8px', marginTop: '1rem',
                    border: '1px solid #bbf7d0', fontSize: '0.9rem', color: '#374151'
                  }}>
                    🎉 {season.highlights}
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Hardy Middle School record book */}
      <div style={{
        background: '#fffbeb',
        padding: '1.5rem',
        borderRadius: '12px',
        margin: '2rem 0',
        textAlign: 'center',
        border: '1px solid #fbbf24'
      }}>
        <h3 style={{ color: '#92400e', marginBottom: '0.5rem' }}>🏅 Looking for results and records?</h3>
        <p style={{ marginBottom: '1rem', color: '#666' }}>
          Coach Dario also keeps the Hardy Middle School cross country and track record
          book—school records plus every performance on file.
        </p>
        <a
          href="https://dareios82.github.io/hardy-xc-track-records/index.html"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'inline-block',
            padding: '0.75rem 1.5rem',
            background: '#d97706',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '8px',
            fontWeight: 'bold'
          }}
        >
          View Hardy Records ↗
        </a>
      </div>
    </div>
  );
}

export default RacingArchive;
